var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"overlay",staticClass:"graph_dialog"},[_c('datalist'),_c('span'),_c('div',{staticClass:"graph_card"},[_c('header',[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('GraphButton',{attrs:{"icon":"close","disabled":_vm.locked},on:{"click":function($event){return _vm.hide()}}})],1),_c('main',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }